/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import 'focus-visible';
import 'intersection-observer';

export function onClientEntry() {
  // Don't need to do anything here, but if you don't
  // export something, the import won't work.
}

import buildOnRouteUpdate from '@root/gatsby-contentful-core/src/utils/gatsby-on-route-update';
import wrapRootElement, { MARKETING_PREFIX } from '@root/joinroot.com/src/utils/gatsby-wrap-root-element';

const onRouteUpdate = buildOnRouteUpdate(MARKETING_PREFIX);

export { wrapRootElement, onRouteUpdate };
